import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../actions";

const initialState = {
  page: 0,
  data: {
    orderForm: 50,
    orderAmount: 0,
    orderNumber: "",
  },
  billingInformation: {
    firstName: "",
    lastName: "",
    company: "",
    phone: "",
    email: "",
    shippingOption: "",
    dropboxLocation: "",
    dropoffDate: "",
    billingMethod: "",
    purchasingAgentName: "",
    purchasingAgentEmail: "",
    poNumber: "",
    grantNumber:"",
    grantPi:"",
    grantNote:"",
    ccNumber: "",
    ccMonth: "",
    ccYear: "",
    cvv: "",
	ccZip: "",
    cardType: "",
    ccName: "",
    acgtCard: "",
  },
  primer: {
    primerList: [],
    primerAmount: "",
    banking: 0,
    comments: "",
    primerSynthesisList: [],
    synthesis: 0,
  },
};

const primerFormSlice = createSlice({
  name: "primerorderform",
  initialState,
  reducers: {
    //action creators
    resetPrimerState(state, action) {
      Object.assign(state, initialState);
      return;
    },
    primerPrevStep: (state, action) => {
      state.page = state.page - 1;
    },
    primerNextStep: (state, action) => {
      state.page = state.page + 1;
    },
    primerSetStep: (state, action) => {
      state.page = action.payload;
    },
    resetPrimerPage: (state, action) => {
      state.page = action.payload;
    },
    initializePrimerTableData(state, action) {
      for (let i = 0; i < action.payload; i++) {
        const newObj = {
          id: i + 1,
          pName: "",
          pSequence: "",
        };
        state.primer.primerSynthesisList.push(newObj);
      }
      return;
    },
    resetPrimerTableData(state,action){
      state.primer.primerSynthesisList = action.payload
    },
    setPrimerAmount(state, action) {
      state.primer.primerAmount = parseInt(action.payload);
      return;
    },
    addPrimerRow: (state, action) => {
      const newRow = action.payload;
      // Add the new row to the end of tableData
      state.primer.primerSynthesisList.push(newRow);

      // Reset the indices in the updated tableData
      state.primer.primerSynthesisList = state.primer.primerSynthesisList.map(
        (item, index) => ({
          ...item,
          id: index + 1,
        })
      );
      state.primer.primerAmount = parseInt(state.primer.primerAmount + 1);
      return;
    },
    editPrimerRow(state, action) {
      const { index, property, value } = action.payload;
      let pattern = /^[a-zA-Z0-9_-]*$/;
      const updatedData = [...state.primer.primerSynthesisList];

		if (property === "pName") {
			if (pattern.test(value)) {
				updatedData[index][property] = value;
			} else {
			// You may want to handle this case differently, e.g., show an error message
			return;
			}
		} else if (property === "pSequence") {
			let pattern2 = /^[acgtACGT]*$/
			if (pattern2.test(value)) {
				updatedData[index][property] = value;
			} else {
			alert(
				"Primers with degenerate bases cannot be used for Sanger sequencing. Primer sequence must match the template it binds to exactly."
				// "Only characters allowed: A, C, G and T"
			);
				return;
			}
		} else {
        updatedData[index][property] = value;
      }

      state.primer.primerSynthesisList = updatedData;
    },
    deleteAllPrimer(state, action) {
      state.primer.primerSynthesisList = action.payload;
      state.primer.primerAmount = "";
      return;
    },
    setPrimerBanking(state, action) {
      state.primer.banking = action.payload;
      return;
    },
    setPrimerList(state, action) {
      const list = action.payload.split(/,\s|\n|,/);
      state.primer.primerList = list;
      // console.log(state.primer.primerList);
      return;
    },
    setPrimerSynthesis(state, action) {   
      state.primer.synthesis = action.payload;
      return;
    },
    setPrimerComments(state, action) {
      // state.primer.comments = action.payload;
        let pattern = /^[a-zA-Z0-9_\- ]*$/;
        let value2 = action.payload

        if (pattern.test(value2)) {
          state.primer.comments = value2;
        } else {
          alert(
            "Only special characters allowed: hyphen( - ) and underscore( _ ) and space."
          );
        }
      return;
    },
    setPrimerDropboxLocation(state, action) {
      state.billingInformation.dropboxLocation = action.payload.label;
      return;
    },
    setPrimerDropoffDate(state, action) {
      state.billingInformation.dropoffDate = action.payload;
    },
    setPrimerFirstName(state, action) {
      state.billingInformation.firstName = action.payload;
      return;
    },
    setPrimerLastName(state, action) {
      state.billingInformation.lastName = action.payload;
      return;
    },
    setPrimerCompany(state, action) {
      state.billingInformation.company = action.payload;
    },
    setPrimerPhone(state, action) {
      const phoneRegex = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
      const result = action.payload;
      state.billingInformation.phone = result;
    },
    setPrimerEmail(state, action) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      state.billingInformation.email = action.payload;
    },
    setPrimerShippingOption(state, action) {
      state.billingInformation.shippingOption = action.payload;
      return;
    },
    setPrimerAcgtCard(state, action) {
      state.billingInformation.acgtCard = action.payload;
      return;
    },
    setPrimerCCNumber(state, action) {
      state.billingInformation.ccNumber = action.payload;
      return;
    },
    setPrimerCCMonth(state, action) {
      state.billingInformation.ccMonth = action.payload;
      return;
    },
    setPrimerCCYear(state, action) {
      state.billingInformation.ccYear = action.payload;
      return;
    },
    setPrimerCVV(state, action) {
      state.billingInformation.cvv = action.payload;
      return;
    },
	setPrimerCCZip(state, action) {
      state.billingInformation.ccZip = action.payload;
      return;
    },
    setPrimerCCName(state, action) {
      state.billingInformation.ccName = action.payload;
      return;
    },
    setPrimerCardType(state, action) {
      state.billingInformation.cardType = action.payload;
      return;
    },
    setPrimerBillingMethod(state, action) {
      state.billingInformation.billingMethod = action.payload;
      return;
    },
    setPrimerPurchasingAgentName(state, action) {
      state.billingInformation.purchasingAgentName = action.payload;
      return;
    },
    setPrimerPurchasingAgentEmail(state, action) {
      state.billingInformation.purchasingAgentEmail = action.payload;
      return;
    },
    setPrimerPoNumber(state, action) {
      state.billingInformation.poNumber = action.payload;
      return;
    },
    setPrimerGrantNumber(state, action) {
      state.billingInformation.grantNumber = action.payload;
      return;
    },
    setPrimerGrantPI(state, action) {
      state.billingInformation.grantPi = action.payload;
      return;
    },
    setPrimerGrantNote(state, action) {
      state.billingInformation.grantNote = action.payload;
      return;
    },
    setPrimerOrderNumber(state, action) {
      state.data.orderNumber = action.payload
    },
    setPrimerOrderAmount(state, action) {
      state.data.orderAmount = action.payload
    }
  },
  //tell our combined reducer to look for additional action types
  extraReducers(builder) {
    builder.addCase(reset, (state, action) => {
      return {};
    });
  },
});

export const {
  resetPrimerState,
  primerNextStep,
  primerPrevStep,
  primerSetStep,
  resetPrimerPage,
  initializePrimerTableData,
  resetPrimerTableData,
  setPrimerAmount,
  addPrimerRow,
  editPrimerRow,
  deleteAllPrimer,
  setPrimerBanking,
  setPrimerList,
  setPrimerSynthesis,
  setPrimerComments,
  setPrimerDropoffDate,
  setPrimerDropboxLocation,
  setPrimerFirstName,
  setPrimerLastName,
  setPrimerCompany,
  setPrimerPhone,
  setPrimerEmail,
  setPrimerShippingOption,
  setPrimerAcgtCard,
  setPrimerCCNumber,
  setPrimerCCMonth,
  setPrimerCCYear,
  setPrimerCVV,
  setPrimerCCZip,
  setPrimerCCName,
  setPrimerCardType,
  setPrimerPurchasingAgentName,
  setPrimerPurchasingAgentEmail,
  setPrimerPoNumber,
  setPrimerGrantNumber,
  setPrimerGrantPI,
  setPrimerGrantNote,
  setPrimerOrderNumber,
  setPrimerOrderAmount,
  setPrimerBillingMethod,
} = primerFormSlice.actions;
export const primerFormReducer = primerFormSlice.reducer;
